import { CardAttributes } from './CardAttributes'

export default CardAttributes
